
// import { FaStar } from "react-icons/fa";
// import { LuCake } from "react-icons/lu";
// import { useNavigate } from "react-router-dom";
// // import "./UpcomingBookings.css";
// import "./../UpcomingBookings/UpcomingBookings.css";


// const YourQuotesBookings = () => {
//   const navigate = useNavigate();

//   const bookings = [
//     {
//       id: 1,
//       title: "Birthday Event",
//       date: "15 Dec, 2025",
//       day: "Monday",
//       rating: 5,
//       status: "Completed",
//       amount: "Rs. 7,000/-",
//     },
//     {
//       id: 2,
//       title: "Birthday Event",
//       date: "15 Dec, 2025",
//       day: "Monday",
//       rating: 5,
//       status: "Completed",
//       amount: "Rs. 7,000/-",
//     },
//     {
//       id: 3,
//       title: "Birthday Event",
//       date: "15 Dec, 2025",
//       day: "Monday",
//       rating: 4,
//       status: "Completed",
//       amount: "Rs. 7,000/-",
//     },
//   ];

// //   const handleViewDetails = (bookingId) => {
// //     navigate("/bookingDetails", { state: { bookingId } });
// //   };

// //   handleChatNow

//   const handleChatNow = (bookingId) => {
//     navigate("/chat", { state: { bookingId } });
//   };

//   return (
//     <div className="booking-list">
//       {bookings.map((booking) => (
//         <div className="booking-card" key={booking.id}>
//           <div className="booking-left">
//             <h3 className="booking-title-upcoming">
//               <LuCake className="cake-icon" />
//               {booking.title}
//             </h3>

//             <p className="booking-date">
//               {booking.date} &nbsp; <span>{booking.day}</span>
//             </p>

//             <div className="booking-rating">
//               <span className="rating-label">Ratings</span>
//               <div className="stars">
//                 {[...Array(booking.rating)].map((_, index) => (
//                   <FaStar key={index} />
//                 ))}
//               </div>
//             </div>

//            <div className="booking-actions">
//               <button className="modify-btn" onClick={() => handleChatNow(booking.id)}>Chat Now</button>

//               {/* <button
//                 className="view-details"
//                 onClick={() => handleViewDetails(booking.id)}
//               >
//                 View Details
//               </button> */}
//             </div>

//           </div>

//           <div className="booking-right">
//             <span className="status completed">{booking.status}</span>
//             <p className="amount">{booking.amount}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default YourQuotesBookings;



import React, { useEffect, useState } from "react";
// import { LuCake } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import "./../UpcomingBookings/UpcomingBookings.css";
import { getAllQuotes } from "../../../../utils/APIs/bookingApis";
import mapEventTypeToConversationalService from "../../../../utils/mapEventTypeToConversationalService";
import Loader from "../../../../Template/Loader/Loader";
// import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";


const YourQuotesBookings = () => {
  const navigate = useNavigate();

  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);

  /* =========================
     FETCH QUOTES (API)
  ========================= */
  useEffect(() => {
    const fetchQuotes = async () => {
      try {
        setLoading(true);
        const response = await getAllQuotes();

        const apiData = response?.data?.data || [];

        // 🔁 Map API response to EXISTING UI structure
        const mappedBookings = apiData.map((item) => {
          const createdDate = new Date(item.startDate || item.date || item.createdAt);
          const eventType = item.eventType || "Custom Quote";

          const isEditing =
            (item.serviceCategory || "").toLowerCase() === "editing" ||
            eventType.toLowerCase().includes("editing");

          return {
            id: item._id,
            title: isEditing ? "Editing" : eventType,
            eventType,
            conversationalService: mapEventTypeToConversationalService(eventType),
            serviceCategory: item.serviceCategory || "",
            subCategoryType: item.subCategoryType || (item.service_id?.serviceName?.toLowerCase().includes("premium") ? "premium" : item.service_id?.serviceName?.toLowerCase().includes("standard") ? "standard" : ""),
            date: createdDate.toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            }),
            day: createdDate.toLocaleDateString("en-IN", {
              weekday: "long",
            }),
            rating: 5,
            status: item.quoteStatus,
            amount: item.budget && item.budget !== "0" && item.budget !== 0 ? `Rs. ${item.budget}/-` : null,
          };
        });

        setBookings(mappedBookings);
      } catch (error) {
        console.error("Failed to fetch quotes", error);
      } finally {
        setLoading(false);
      }
    };

    fetchQuotes();
  }, []);

  // const handleChatNow = (bookingId) => {
  //   navigate("/chat", { state: { bookingId } });
  // };

  const handleChatNow = (booking) => {
    navigate(`/chat/${booking.id}`, {
      state: {
        quoteId: booking.id,
        eventType: booking.eventType,
        serviceName: booking.conversationalService || booking.eventType,
      },
    });
  };

  return (
    <>
      {loading && <Loader />}

      <div className="booking-list">
        {bookings.map((booking) => (


          <div className="booking-card" key={booking.id}>
            <div className="booking-left">
              <h3 className="booking-title-upcoming">
                {booking.serviceCategory?.toLowerCase() === "hourly" && (
                  <>
                    {booking.eventType || booking.title}
                    <span className="service-tag hourly">Hourly</span>
                    {booking.subCategoryType && (
                      <span className="plan-tag">
                        {booking.subCategoryType.charAt(0).toUpperCase() + booking.subCategoryType.slice(1)}
                      </span>
                    )}
                  </>
                )}

                {booking.serviceCategory?.toLowerCase() === "editing" && (
                  <span className="service-tag editing">Editing</span>
                )}

                {booking.serviceCategory?.toLowerCase() !== "hourly" &&
                  booking.serviceCategory?.toLowerCase() !== "editing" && (
                    <>{booking.title}</>
                  )}
              </h3>

              <p className="booking-date">
                {booking.date} &nbsp; <span>{booking.day}</span>
              </p>

              {/* <div className="booking-rating">
                <span className="rating-label">Ratings</span>
                
                 <div className="stars">
                              {[...Array(5)].map((_, index) => {
                                const rating = booking.ratingsGivenByClient || 0;
                
                                if (rating >= index + 1) {
                                  // Full star
                                  return <FaStar key={index} />;
                                } else if (rating >= index + 0.5) {
                                  // Half star
                                  return <FaStarHalfAlt key={index} />;
                                } else {
                                  // Empty star
                                  return <FaRegStar key={index} />;
                                }
                              })}
                            </div>
              </div> */}

              <div className="booking-actions">
                <button
                  className="modify-btn"
                  onClick={() => handleChatNow(booking)}
                >
                  Chat Now
                </button>
              </div>
            </div>

            <div className="booking-right">
              <span className="status completed">
                {booking.status}
              </span>
              {booking.amount && <p className="amount">{booking.amount}</p>}
            </div>
          </div>
        ))}

        {!loading && bookings.length === 0 && (
          <p className="text-center mt-4">No quotes found</p>
        )}
      </div>
    </>
  );
};

export default YourQuotesBookings;
